import type { DisplayMode as DatePickerDisplayMode } from '../types';
import type { DisplayMode as LegacyDisplayMode } from './types';

export const normalizeLegacyDisplayMode = (
  displayMode?: LegacyDisplayMode | DatePickerDisplayMode,
): DatePickerDisplayMode => {
  if (displayMode == null) {
    return 'popover';
  }
  return displayMode === 'bottomSheet' ? 'bottom-sheet' : displayMode;
};
